export default "<app-navigation></app-navigation>"